import { FC, Ref } from 'react';

import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { ProductTotalAndOldPrice } from './ProductTotalAndOldPrice';
import { PriceBig, PriceContainer } from './TopPrice.styles';

type Props = {
    ref: Ref<HTMLElement>;
};

export const PriceWithoutMonthlyPayment: FC<Props> = ({ ref }) => {
    return (
        <PriceContainer data-test={ESHOP_TEST_ID.PRICE_WITHOUT_MONTHLY_PAYMENT} ref={ref as Ref<HTMLDivElement>}>
            <PriceBig>
                <ProductTotalAndOldPrice />
            </PriceBig>
        </PriceContainer>
    );
};
